import React from 'react';
import { BlackText, Container, ProgressFill, TextOverlay, WhiteText } from './styles';
import { ProgressButtonProps } from './types';

const ProgressButton: React.FC<ProgressButtonProps> = ({
    progress,
    onClick,
    children,
    disabled,
    ...props
}) => {
    const clampedProgress = Math.max(0, Math.min(1, progress));

    return (
        <Container disabled={disabled} onClick={onClick} {...props}>
            <ProgressFill style={{ width: `${clampedProgress * 100}%` }} />
            <TextOverlay>
                <WhiteText variant="caption" weight="bold">
                    {children}
                </WhiteText>
                <BlackText
                    variant="caption"
                    weight="bold"
                    style={{ clipPath: `inset(0 0 0 ${clampedProgress * 100}%)` }}
                >
                    {children}
                </BlackText>
            </TextOverlay>
        </Container>
    );
};

export default ProgressButton;
